var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('TopNav'),_c('div',{staticClass:"map_container",attrs:{"id":"map"}}),(_vm.loading)?_c('b-spinner',{staticClass:"spinner",staticStyle:{"width":"5rem","height":"5rem"},attrs:{"label":"Large Spinner","type":"grow"}}):_vm._e(),(_vm.loading)?_c('div',{staticClass:"overlay"}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }